// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.0-beta.64154abea',
  revision: '64154abea',
  branch: 'develop',
  date: 'Fri, 20 Mar 2026 09:46:57 GMT'
};